import AkunSelect from "@/components/app/AkunSelect";
import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { rupiah, todayISO, toDateInput } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { CurrencyInput } from "@/components/app/CurrencyInput";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { PackageCheck } from "lucide-react";

export const SelesaiBriketDialog = ({ open, setOpen, item, onSaved }) => {
  const [form, setForm] = useState({});
  useEffect(() => {
    if (!open || !item) return;
    const done = item.status === "selesai";
    setForm({ tanggal_selesai: done ? toDateInput(item.tanggal_selesai) : todayISO(), output_kg: done ? item.output_kg : "",
      biaya_tambahan: done ? item.biaya_tambahan : 0, keterangan: item.keterangan_selesai || "", akun_id: item.akun_id_selesai || "" });
  }, [open, item]);
  if (!item) return null;

  const kg = Number(form.output_kg || 0);
  const awal = Number(item.biaya_kulitan || 0) + Number(item.biaya_bahan_luar || 0) + Number(item.biaya_operasional || 0);
  const total = awal + Number(form.biaya_tambahan || 0);
  const hpp = kg > 0 ? Math.round(total / kg) : 0;
  const upd = (k) => (e) => setForm({ ...form, [k]: e && e.target ? e.target.value : e });

  const save = async (e) => {
    e?.preventDefault();
    if (!form.tanggal_selesai) { toast.error("Tanggal selesai wajib diisi"); return; }
    if (!(kg > 0)) { toast.error("Hasil Briket (Kg) wajib diisi (lebih dari 0)"); return; }
    try {
      await api.post(`/batch-briket/${item.id}/selesai`, { tanggal_selesai: form.tanggal_selesai, output_kg: kg,
        biaya_tambahan: Number(form.biaya_tambahan || 0), keterangan: form.keterangan || "", akun_id: form.akun_id || null });
      toast.success("Briket selesai & stok briket bertambah");
      setOpen(false); onSaved();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-lg" data-testid="selesai-briket-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><PackageCheck size={18} className="text-emerald-600"/>Briket Selesai — {item.produk_nama}</DialogTitle></DialogHeader>
        <div className="text-xs bg-slate-50 border border-slate-200 rounded-sm p-2 text-slate-700">Biaya s.d. cetak: <b>{rupiah(awal)}</b></div>
        <form onSubmit={save} className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-1.5"><Label>Tanggal Selesai <span className="text-rose-500">*</span></Label><Input type="date" value={form.tanggal_selesai || ""} onChange={upd("tanggal_selesai")} data-testid="selesai-tanggal"/></div>
          <div className="space-y-1.5"><Label>Hasil Briket (Kg) <span className="text-rose-500">*</span></Label><Input type="number" min="0" step="0.01" value={form.output_kg} onChange={upd("output_kg")} data-testid="selesai-kg"/></div>
          <div className="md:col-span-2 space-y-1.5"><Label>Biaya Jemur/Oven (Rp)</Label><CurrencyInput value={form.biaya_tambahan} onValueChange={upd("biaya_tambahan")} data-testid="selesai-biaya"/></div>
          <div className="md:col-span-2 space-y-1.5"><Label>HPP / Kg (otomatis)</Label><div className="h-9 px-3 flex items-center border border-slate-200 bg-blue-50 font-mono font-semibold brand-text" data-testid="selesai-hpp">{rupiah(hpp)} / Kg</div></div>
<AkunSelect className="md:col-span-2" label="Biaya dibayar dari akun" value={form.akun_id} onChange={(v) => setForm((f) => ({ ...f, akun_id: v }))} testid="selesai-akun"/>
          <div className="md:col-span-2 space-y-1.5"><Label>Keterangan</Label><Textarea value={form.keterangan || ""} onChange={upd("keterangan")} data-testid="selesai-keterangan"/></div>
          <button type="submit" className="hidden" aria-hidden="true"/>
        </form>
        <DialogFooter>
          <Button variant="outline" onClick={() => setOpen(false)} className="rounded-sm">Batal</Button>
          <Button onClick={save} className="brand-btn rounded-sm" data-testid="selesai-save">Simpan Hasil</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
